import {Switch} from '../../Switch/Switch';
import {useFieldProps} from '../hooks/useFieldProps';
import {SwitchRendererResponseBody} from '../types/modelSchema';

export function SwitchRenderer(props: SwitchRendererResponseBody) {
  const {name, tooltip} = props;
  const {onChange, onBlur, onFocus, value, error, isRequired} = useFieldProps(props);

  return (
    <Switch
      label={props.label}
      data-testid={name}
      onChange={onChange}
      isRequired={isRequired}
      errorMessage={error?.message}
      onFocus={onFocus}
      tooltip={tooltip}
      onBlur={onBlur}
      value={value || ''}
      isDisabled={props.isReadOnly}
    />
  );
}
